import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ValidatorEditorBase } from '../validator-editor-base/validator-editor-base';
import { UnionCheckValidatorModel, UnionCheckRelation } from '../../../types/validator.types';
import { UnionCheckRelationService } from '../../../services/union-check-relation.service';

@Component({
  selector: 'df-union-check-validator-editor',
  templateUrl: './union-check-validator-editor.component.html',
  styleUrls: ['./union-check-validator-editor.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnionCheckValidatorEditorComponent extends ValidatorEditorBase<UnionCheckValidatorModel>
  implements OnInit {
  relations: UnionCheckRelation[];
  _relation: string;

  constructor(private unionCheckRelationService: UnionCheckRelationService) {
    super();
  }

  ngOnInit() {
    if (!this.caption) {
      this.caption = 'å³èæ ¡éª';
    }
    this.relations = this.unionCheckRelationService.getUnionRelations();
  }

  afterModelInit() {
    // const customRegex = this.getValidatorModelByRegexName(this.customRegexName);
    if (!this.data) {
      return;
    }
  }

  defaultModelData(): UnionCheckValidatorModel {
    return {
      unionId: '',
      unionRelation: ''
    };
  }
}
